module.exports = __webpack_public_path__ + "img/HC2010-175.5da52324.jpg";